import { render, staticRenderFns } from "./MedicoesCadastro.vue?vue&type=template&id=3fbc6ff8&scoped=true&"
import script from "./MedicoesCadastro.vue?vue&type=script&lang=js&"
export * from "./MedicoesCadastro.vue?vue&type=script&lang=js&"
import style0 from "./MedicoesCadastro.vue?vue&type=style&index=0&id=3fbc6ff8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fbc6ff8",
  null
  
)

export default component.exports